import analytics from'./Analytics';
export  default analytics;